// ホーム ヘッダーポジション
export default function homeHeaderPosition () {

	const media = window.matchMedia('(min-width: 768px)')
	const header = document.querySelector('.header')
	const hero = document.querySelector('.home-hero')

	let alive = false
	let isSticky = false
	let headerH
	let heroH

	const update = () => {
		const _isSticky = window.pageYOffset > heroH - headerH;
		if (_isSticky === isSticky) {
			return;
		}
		isSticky = _isSticky
		if (isSticky) {
			header.classList.add('is--sticky')
		} else {
			header.classList.remove('is--sticky')
		}
	}

	const onScroll = update

	const onResize = () => {
		headerH = header.offsetHeight
		heroH = hero.offsetHeight
		update()
	}

	const live = () => {
		if (alive) {
			return
		}
		alive = true
		onResize()
		window.addEventListener('scroll', onScroll)
		window.addEventListener('resize', onResize)
	}

	const kill = () => {
		if (!alive) {
			return
		}
		alive = false
		isSticky = false
		header.classList.remove('is--sticky')
		window.addEventListener('scroll', onScroll)
		window.addEventListener('resize', onResize)
	}

	if (media.matches) {
		live()
	}

	media.addListener(function(){
		if (media.matches) {
			live()
		} else {
			kill()
		}
	})

}
